import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { useScrollable } from './useScrollable';
export const ScrollableContent = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const {
    isScrolledVertically,
    setIsScrolledVertically
  } = useScrollable();
  let t1;
  if ($[0] !== isScrolledVertically || $[1] !== setIsScrolledVertically) {
    t1 = event => {
      const target = event.target as HTMLDivElement;
      if (typeof target.scrollTop === "number") {
        const isScrolled = target.scrollTop > 0;
        if (isScrolled !== isScrolledVertically) {
          setIsScrolledVertically(isScrolled);
        }
      }
    };
    $[0] = isScrolledVertically;
    $[1] = setIsScrolledVertically;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      flexGrow: 1
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1) {
    t3 = <Stack className="overflow-auto" onScroll={t1} sx={t2}>{children}</Stack>;
    $[4] = children;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};